var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-cont",attrs:{"tabindex":"0"},on:{"click":_vm.changePaneState,"keyup":_vm.changePaneState}},[(_vm.paneOpen)?_c('rare-collapse-icon'):_vm._e(),(!_vm.paneOpen)?_c('rare-expand-icon'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }